/**
 * Session urgency — a boolean flag a clinician sets to mark a session as
 * needing attention sooner. Backed by the `is_urgent` field on the session
 * model (ml-scribe; default `false`), set via the session update endpoint
 * (owner + team-member) and returned on every session read view — see
 * `docs/contracts/session-urgency.md`. It lives on the shared session, so any
 * teammate who can see the session (e.g. an assistant) sees it.
 */

/**
 * Reads `is_urgent` off any session-shaped object, defaulting absent/null to
 * `false`. Accepts `unknown` because the generated session schemas don't carry
 * `is_urgent` until the OpenAPI types are regenerated — so callers pass
 * `SessionListItem`, `SimpleSessionResponse`, etc. without a cast at every site.
 */
export const isSessionUrgent = (session: unknown): boolean => {
  return (
    (session as { is_urgent?: boolean | null } | null | undefined)?.is_urgent === true
  );
};
